// Header scroll behavior
(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        const header = document.getElementById('header');
        if (!header) return;

        const scrollThreshold = 50; // pixels to scroll before adding class

        function handleScroll() {
            if (window.scrollY > scrollThreshold) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        }

        // Initial check
        handleScroll();

        // Listen to scroll events (throttled for performance)
        let ticking = false;
        window.addEventListener('scroll', function() {
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    handleScroll();
                    ticking = false;
                });
                ticking = true;
            }
        });
    });
})();
